import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Parse from 'html-react-parser';
import {
  Link,
  withRouter,
} from 'react-router-dom';
import {
  Button,
  Form,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { login } from '../../actions/Auth';

import { APIpasswordChange } from '../../api/Auth';

import InputPassword from '../../components/InputPassword';
import ProcessingSpinner from '../../components/ProcessingSpinner';

import {
  getStateFromUrl,
  parseResponseErrors,
} from '../../helpers';

import ErrorBoundary from '../../components/ErrorBoundary';

class PasswordResetChangeForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
      password_confirmation: '',
      error: null,
      success: false,
      loading: false,
      landingUrl: '/',
      backToIntegration: false,
      g2fa: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  getButtonText() {
    const {
      intl,
      isActivation,
      isUserActivation,
    } = this.props;

    if (isActivation || isUserActivation) {
      return intl.formatMessage({ defaultMessage: 'Set and go to your workspace' });
    }

    return intl.formatMessage({ defaultMessage: 'Set up a new password' });
  }

  handleChange(e) {
    const { state } = this;
    state[e.target.name] = e.target.value;
    this.setState(state);
  }

  handleSubmit(e) {
    e.persist();
    e.preventDefault();

    const { name: buttonName } = e.nativeEvent.submitter;
    let redirectUrl = null;
    if (buttonName === 'backToIntegration') {
      this.setState({ backToIntegration: true });
      redirectUrl = getStateFromUrl().redirect_url;
    } else {
      this.setState({ backToIntegration: false });
    }

    this.setState({
      loading: true,
      error: null,
    });

    if (!this.isFormValid()) {
      this.setState({ loading: false });
      return;
    }

    const {
      intl,
      dispatch,
      history,
      token,
      isActivation,
      isUserActivation,
    } = this.props;
    const {
      password,
      password_confirmation: passwordConfirmation,
    } = this.state;

    APIpasswordChange({
      token,
      password,
      password_confirmation: passwordConfirmation,
      activate: isActivation || isUserActivation,
      request_id: getStateFromUrl()?.request_id || undefined,
    }).then((response) => {
      const { data } = response;
      if (data.status === 'OK') {
        if (data.email && !data.g2fa_enabled) {
          dispatch(login({
            username: data.email,
            password,
            clearAuthDataOnError: false,
          })).then((r) => {
            if (parseInt(r.status) === 200) {
              if (isActivation || isUserActivation) {
                if (redirectUrl) {
                  window.location = redirectUrl;
                } else {
                  history.push(data.landing_url || '/');
                }
              } else {
                this.setState({
                  success: true,
                  landingUrl: data.landing_url,
                });
              }
            } else {
              this.setState({ error: intl.formatMessage({ defaultMessage: 'Something went wrong' }) });
            }
          });
        } else if (data.g2fa_enabled) {
          this.setState({
            success: true,
            g2fa: true,
          });
        }
      } else {
        this.setState({
          error: Object.values(parseResponseErrors(response)).join(', '),
          loading: false,
        });
      }
    }).catch((error) => {
      this.setState({
        error: Object.values(parseResponseErrors(error.response)).join(', '),
        loading: false,
      });
    });
  }

  isFormValid() {
    const {
      intl,
    } = this.props;
    const {
      password,
      password_confirmation: passwordConfirmation,
    } = this.state;

    if (!password) {
      this.setState({ error: intl.formatMessage({ defaultMessage: 'Enter new password' }) });
      return false;
    }
    if (!passwordConfirmation) {
      this.setState({ error: intl.formatMessage({ defaultMessage: 'Confirm new password' }) });
      return false;
    }
    if (password !== passwordConfirmation) {
      this.setState({ error: intl.formatMessage({ defaultMessage: 'Passwords do not match' }) });
      return false;
    }

    return true;
  }

  render() {
    const {
      error,
      success,
      loading,
      landingUrl,
      backToIntegration,
      g2fa,
    } = this.state;
    const {
      intl,
      isActivation,
      isUserActivation,
      passwordExpired,
    } = this.props;

    const state = getStateFromUrl();

    return (
      <ErrorBoundary>
        {success ? (
          <div className="mt-4">
            <p className="center">
              {(passwordExpired || !isActivation) ? (
                <>
                  {intl.formatMessage({ defaultMessage: 'Your password has been changed.' })}<br />
                  {g2fa ? (
                    intl.formatMessage(
                      { defaultMessage: 'Now you can <link>login to Stockpress</link>.' },
                      { link: msg => <Link to="/login">{msg}</Link> },
                    )
                  ) : (
                    intl.formatMessage(
                      { defaultMessage: 'Now you can <link>go back to Stockpress</link>.' },
                      { link: msg => <Link to={landingUrl}>{msg}</Link> },
                    )
                  )}
                </>
              ) : (
                <>
                  {intl.formatMessage({ defaultMessage: 'Thank you, your password has been set.' })}<br />
                  {intl.formatMessage(
                    { defaultMessage: 'If you are not redirected to your workspace, click <link>here</link>.' },
                    {
                      link: msg => <Link to={landingUrl}>{msg}</Link>,
                    },
                  )}
                </>
              )}
            </p>
          </div>
        ) : (
          <Form
            className="login-form"
            onChange={this.handleChange}
            onSubmit={this.handleSubmit}
          >
            <div>
              <p className="center">
                {passwordExpired && (
                  <>
                    {intl.formatMessage({ defaultMessage: 'Your password expired' })}<br />
                  </>
                )}
                {intl.formatMessage(
                  { defaultMessage: 'Set up your new password {toActivate, select, yes { to activate your account} other {}}' },
                  { toActivate: isActivation || isUserActivation ? 'yes' : 'no' },
                )}
              </p>
              {window.sp.passwordRequirements && (
                <p className="info center">
                  {intl.formatMessage({ defaultMessage: 'Password requirements:' })}<br />
                  {window.sp.passwordRequirements}
                </p>
              )}
            </div>
            {error && (
              <div className="error">
                {Parse(error)}
              </div>
            )}
            <div className="groups-wrapper">
              <InputPassword
                name="password"
                placeholder={intl.formatMessage({ defaultMessage: 'New password' })}
                autoFocus
                disabled={loading}
              />
              <InputPassword
                name="password_confirmation"
                placeholder={intl.formatMessage({ defaultMessage: 'Confirm new password' })}
                disabled={loading}
              />
            </div>
            <div className="login-forgot">
              {(!passwordExpired && !isActivation) && (
                <Link to="/login">
                  {intl.formatMessage({ defaultMessage: 'Back to Login' })}
                </Link>
              )}
            </div>
            {state?.integration && (
              <div className="btn-wrapper mb-4">
                <Button
                  type="submit"
                  name="backToIntegration"
                  disabled={loading}
                  color="primary"
                >
                  <ProcessingSpinner show={loading && backToIntegration} />
                  {intl.formatMessage(
                    { defaultMessage: 'Set and return to {name}' },
                    { name: state.integration.name },
                  )}
                </Button>
              </div>
            )}
            <div className="btn-wrapper">
              <Button
                type="submit"
                disabled={loading}
                color="primary"
              >
                <ProcessingSpinner show={loading && !backToIntegration} />
                {this.getButtonText()}
              </Button>
            </div>
          </Form>
        )}
      </ErrorBoundary>
    );
  }
}

PasswordResetChangeForm.propTypes = {
  intl: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,
  isActivation: PropTypes.bool.isRequired,
  isUserActivation: PropTypes.bool.isRequired,
  passwordExpired: PropTypes.bool.isRequired,
};

export default withRouter(connect()(injectIntl(PasswordResetChangeForm)));
